import { FC } from 'react';
import { useUnit } from 'effector-react';
import { $pathname, HaveSectionAccess } from '@features/common';
import { ThemeAdapter } from '@shared/theme/adapter';
import { FilterMainDetailLayout } from '@shared/ui';
import { ErrorMessage } from '@ui/index';
import {
  $error,
  $isErrorDialogOpen,
  PageGate,
  changedErrorDialogVisibility,
  $isDetailOpen,
  $isFilterOpen,
} from '../models';
import '../models/detail-sdui-opened-id';
import { $isReplaceEmployee } from '../models/replace-employee';
import { Toast } from '../models/toast/ui';
import { ErrorSduiRequestMessage } from '../molecules/errorSduiRequests';
import { TicketsVersionBlock } from '../molecules/ticketsVersionBlock';
import { Table, Filters } from '../organisms';
import { DetailWrap } from '../organisms/detail';
import { ReplaceEmploeeErrorMessage } from '../organisms/detail-replace-employee/components/error';
import * as Styled from './styled';
import { TicketPage } from './ticket';

const TicketsPage: FC = () => {
  const [
    isErrorDialogOpen,
    error,
    isDetailOpen,
    isFilterOpen,
    isReplaceEmployee,
    pathname,
  ] = useUnit([
    $isErrorDialogOpen,
    $error,
    $isDetailOpen,
    $isFilterOpen,
    $isReplaceEmployee,
    $pathname,
  ]);

  const ticketId = (pathname as string).split('/')[2];

  const newVersion = localStorage.getItem('ticketsNewVersion') === 'new' ? true : false;
  if (newVersion === false && !!ticketId) {
    return <TicketPage />;
  }

  const onClose = () => changedErrorDialogVisibility(false);

  return (
    <Styled.Container>
      <PageGate ticketId={ticketId} />

      <TicketsVersionBlock />

      <ErrorMessage isOpen={isErrorDialogOpen} onClose={onClose} error={error} />

      <ErrorSduiRequestMessage />

      <ReplaceEmploeeErrorMessage />

      <Toast />

      <FilterMainDetailLayout
        filter={isFilterOpen && <Filters />}
        main={<Table />}
        detail={(isDetailOpen || isReplaceEmployee) && <DetailWrap />}
        params={{
          filterWidth: '400px',
          detailWidth: !isFilterOpen
            ? isReplaceEmployee
              ? '560px'
              : 'minmax(370px, 50%)'
            : '40%',
        }}
      />
    </Styled.Container>
  );
};

const RestrictedTicketsPage: FC = () => (
  <HaveSectionAccess>
    <ThemeAdapter>
      <TicketsPage />
    </ThemeAdapter>
  </HaveSectionAccess>
);

export default RestrictedTicketsPage;
